import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaCheck } from 'react-icons/fa';

import { Text, RegularText } from '../../common/Text';
import downloadPdf from '../../../images/consultations/downloadPdf.svg';
import StyledTappable from '../../common/StyledTappable';

const OuterContainer = styled(StyledTappable)`
  display: flex;
  flex-shrink: 0;
  max-width: 80%;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0.4rem 0;
`;

const BubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 1rem 1.2rem;
  background: #f7f7f7;
  border-radius: 1.4rem;
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
`;

const FileIcon = styled.img`
  width: 3.6rem;
  margin-right: 0.8rem;
  color: #fff;
`;

const FileName = styled(Text)`
  flex: 1;
  font-size: 1.6rem;
`;

const TimestampContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  margin-right: 1.6rem;
`;

const TickIcon = styled(FaCheck)`
  opacity: 0.5;
  font-size: 1rem;
  margin-right: 0.4rem;
`;

const TimestampText = styled(RegularText)`
  opacity: 0.5;
  font-size: 1.2rem;
`;

const DoctorFileMessage = ({ fileName, url, timestamp }) => (
  <OuterContainer onTap={() => window.open(url)}>
    <BubbleContainer>
      <MessageContainer>
        <FileIcon src={downloadPdf} />
        <FileName>{fileName}</FileName>
      </MessageContainer>
      {timestamp && (
        <TimestampContainer>
          <TickIcon />
          <TimestampText>
            {new Date(timestamp).toLocaleTimeString('nu', {
              hour: 'numeric',
              minute: '2-digit',
            })}
          </TimestampText>
        </TimestampContainer>
      )}
    </BubbleContainer>
  </OuterContainer>
);

DoctorFileMessage.propTypes = {
  fileName: PropTypes.string,
  url: PropTypes.string,
  timestamp: PropTypes.number,
};

export default DoctorFileMessage;
